"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepAddons = void 0;
const react_1 = __importDefault(require("react"));
const Button_1 = __importDefault(require("react-bootstrap/Button"));
const CardDeck_1 = __importDefault(require("react-bootstrap/CardDeck"));
const Col_1 = __importDefault(require("react-bootstrap/Col"));
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const Row_1 = __importDefault(require("react-bootstrap/Row"));
const configContext_1 = require("../../context/configContext");
const BookingItem_1 = require("../../models/BookingItem");
const ScrollToTopController_1 = require("../../utils/ScrollToTopController");
const AddonCard_1 = require("../addon-card/AddonCard");
const IconChevronLeft_1 = require("../icons/IconChevronLeft");
const StepAddons = (props) => {
    const config = (0, configContext_1.useConfig)();
    /** Handles the quantity change. */
    function handleQuantityChange(configAddonItem, newQuantity) {
        // Create an array without the changed addon.
        const newAddons = props.booking.addonItems.filter((addon) => addon.type !== configAddonItem.type ||
            addon.title !== configAddonItem.title);
        // Keep quantity inside min and max.
        const newQuantityInLimits = Math.max(Math.min(configAddonItem.maxQuantity, newQuantity), configAddonItem.minQuantity);
        // Add (again) if quantity is greater than 0.
        if (newQuantityInLimits > 0) {
            const addonItem = new BookingItem_1.BookingItem(config, configAddonItem);
            addonItem.quantity = newQuantityInLimits;
            newAddons.push(addonItem);
        }
        props.onBookingChange({ addonItems: newAddons });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ScrollToTopController_1.ScrollToTop, null),
        react_1.default.createElement("h3", null, props.type),
        react_1.default.createElement(Form_1.default, { noValidate: true, onSubmit: props.onNext },
            react_1.default.createElement(CardDeck_1.default, { className: "addon-cards" }, props.configAddonItems.map((configAddon) => {
                // Check if we have a corresponding item in the booking.
                const addonItem = props.booking.addonItems.find((addon) => addon.type === configAddon.type &&
                    addon.title == configAddon.title);
                // If available use the quantity from the booking.
                // Otherwise set the initial quantity to min quantity.
                const quantity = addonItem
                    ? addonItem.quantity
                    : configAddon.minQuantity;
                return (react_1.default.createElement(AddonCard_1.AddonCard, { key: configAddon.type + configAddon.title, configAddonItem: configAddon, fullDay: props.booking.isFullDay(), quantity: quantity, onQuantityChange: (newQuantity) => handleQuantityChange(configAddon, newQuantity) }));
            })),
            react_1.default.createElement(Row_1.default, null,
                react_1.default.createElement(Col_1.default, null,
                    react_1.default.createElement(Button_1.default, { variant: "link", onClick: props.onPrevious },
                        react_1.default.createElement(IconChevronLeft_1.IconChevronLeft, null),
                        " Zur\u00FCck")),
                react_1.default.createElement(Col_1.default, { className: "text-right" },
                    react_1.default.createElement(Button_1.default, { variant: "primary", size: "lg", onClick: props.onNext }, "Weiter"))))));
};
exports.StepAddons = StepAddons;
